import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router';
import { queryClient } from './api/hooks';
import { AccessGate } from './app/AccessGate';
import { Shell } from './app/Shell';
import { AiCostPage } from './pages/AiCost';
import { AuditPage } from './pages/Audit';
import { InsightsPage } from './pages/Insights';
import { ContentPage } from './pages/Content';
import { DashboardPage } from './pages/Dashboard';
import { FlagsPage } from './pages/Flags';
import { GrowthPage } from './pages/Growth';
import { AppConfigPage } from './pages/AppConfig';
import { ServerSettingsPage } from './pages/ServerSettings';
import { JobsPage } from './pages/Jobs';
import { MangaPage } from './pages/Manga';
import { ModerationPage } from './pages/Moderation';
import { NotFoundPage } from './pages/NotFound';
import { NotificationsPage } from './pages/Notifications';
import { StoryPage } from './pages/Story';
import { TeamPage } from './pages/Team';
import { UserDetailPage } from './pages/UserDetail';
import { UsersPage } from './pages/Users';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AccessGate>
        <BrowserRouter>
          <Routes>
            <Route element={<Shell />}>
              <Route index element={<DashboardPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="users/:id" element={<UserDetailPage />} />
              <Route path="moderation" element={<ModerationPage />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="insights" element={<InsightsPage />} />
              <Route path="ai-cost" element={<AiCostPage />} />
              <Route path="growth" element={<GrowthPage />} />
              <Route path="jobs" element={<JobsPage />} />
              <Route path="story" element={<StoryPage />} />
              <Route path="manga" element={<MangaPage />} />
              <Route path="content" element={<ContentPage />} />
              <Route path="flags" element={<FlagsPage />} />
              <Route path="app-config" element={<AppConfigPage />} />
              <Route path="settings" element={<ServerSettingsPage />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="audit" element={<AuditPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AccessGate>
    </QueryClientProvider>
  );
}
